<template>
  <v-alert type="info" dense text>
    <div>
      <strong>Legenda:</strong> <span>Selecione as filiais desejadas para a campanha.</span>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'FilialLegendas',
  props: {
    organicos: {
      type: Boolean,
      default: false
    }
  }
};
</script>
